<template>
    <div class="downloads">
        <a :href="`${directusUrl}/assets/${download.id}`" v-for="download in downloads" target="_blank" rel="noopener noreferrer">
            <NButton size="large" icon-placement="right">
                <template #icon>
                    <IconDownload />
                </template>
                <div class="title" v-html="download.title" />
            </NButton>
        </a>
    </div>
</template>

<script lang="ts" setup>
import { NButton } from 'naive-ui'
const directusUrl = useDirectusUrl()
defineProps<{ downloads?: any[] }>()
</script>

<style lang="scss" scoped>
.downloads {
    display: flex;
    gap: var(--size-gutter-small);
    flex-wrap: wrap;
    max-width: var(--text-maxwidth-body);

    .title {
        word-break: break-word;
        white-space: normal;
        line-height: var(--text-line-body);
    }
}

.n-button {
    height: fit-content;
    padding: var(--size-gutter-default);
    text-align: left;
}
</style>